import { Link } from 'react-router-dom';
import { createUseStyles } from 'src/theming';
import { Chip, ListItem, ListItemText } from '@material-ui/core';
import React, { FC, memo } from 'react';
import Contact, { LegacyContact } from 'src/interfaces/api/Contact';
import CustomerAccessAction from './components/CustomerAccessAction';

const linkToContact = (contactId: number) => `/dashboard/contact/${contactId}`;
const linkToContactV2 = (contactId: string) => `/dashboard/crm/contacts/${contactId}`;

const useStyles = createUseStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  success: {
    color: '#4caf50',
  },
  chip: {
    marginLeft: 10,
  },
});

interface Props {
  siteId?: string;
  contactV2?: Contact;
  contact?: LegacyContact;
  onAskContactAccess?: () => void;
  onRevokeContactAccess?: () => void;
}

const ContactRow: FC<Props> = ({ contact, contactV2, siteId, onAskContactAccess, onRevokeContactAccess }) => {
  const classes = useStyles();

  const getContactJobLabel = () => {
    if (contact?.job) {
      return contact.job;
    } else if (contactV2?.job) {
      return contactV2.job;
    }

    return 'non-renseigné';
  };

  const getContactNameLabel = () => {
    if (contact) {
      return contact.name + ' ' + contact.lastname;
    } else if (contactV2) {
      return contactV2.firstname + ' ' + contactV2.lastname;
    }

    return '--- ---';
  };

  return (
    <ListItem>
      <ListItemText
        primary={
          <Link to={contact?.id ? linkToContact(contact.id) : contactV2?.id ? linkToContactV2(contactV2.id) : '#'}>
            <span>
              {getContactNameLabel()}
              {!contact && contactV2 && <Chip className={classes.chip} label='Nouveau CRM' size='small' />}
            </span>
          </Link>
        }
        secondary={getContactJobLabel()}
      />

      <CustomerAccessAction
        onClickCreateAccess={onAskContactAccess}
        onClickRevokeAccess={onRevokeContactAccess}
        contactCreated={contactV2 !== undefined}
        canCreateAccess={siteId !== undefined}
      />
    </ListItem>
  );
};

export default memo(
  ContactRow,
  (prevProps, nextProps) =>
    prevProps.contact?.id === nextProps.contact?.id &&
    prevProps.contactV2?.id === nextProps.contactV2?.id &&
    prevProps.siteId === nextProps.siteId
);
